import { queryClient } from './queryClient';

// localStorage keys that belong to the currently signed-in user. Cleared
// on logout / 401 so a second account signing in on the same browser does
// not inherit the previous user's preferences, drafts, or expanded state.
//
// Device-level keys (bb_theme, bb_language, hideDevtools) are intentionally
// left untouched.
const USER_SCOPED_KEYS = [
  'only_my_tasks',
  'task_detail_view_mode',
  'expandedSidebarProjects',
  'teamOrder',
  'busybee_ai_chat',
  'busybee_search_recent',
  'bb.cache',  // the phone app's saved data (lib/persistCache.js)
  'bb.user',   // and its signed-in user (contexts/AuthContext.jsx)
  'bb.viewtabs',  // and its view tabs (hooks/useViewTabs.js)
];

// Prefixes for per-entity user state (per-task note drafts, per-document
// DB view config). Stripped by prefix scan since the entity ids are dynamic.
const USER_SCOPED_KEY_PREFIXES = ['notes_draft_', 'db-view:'];

export const clearUserScopedSession = () => {
  // Signing out must go on even if the query cache cannot be emptied.
  try {
    queryClient.cancelQueries();
  } catch { /* see above */ }
  try {
    queryClient.clear();
  } catch { /* see above */ }
  try {
    USER_SCOPED_KEYS.forEach((k) => localStorage.removeItem(k));
    for (let i = localStorage.length - 1; i >= 0; i--) {
      const key = localStorage.key(i);
      if (key && USER_SCOPED_KEY_PREFIXES.some((p) => key.startsWith(p))) {
        localStorage.removeItem(key);
      }
    }
  } catch { /* storage blocked: nothing was kept there */ }
};
